import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {  Grid, Table, TableBody, TableContainer, TableHead ,CircularProgress} from "@mui/material";
import { CustomTablePagination, StyledTableCell, StyledTableRow } from "../../Components/MaterialTableStyle/MaterialTableStyle";
import { StatusStyle } from "../../Components/MaterialButtonStyle/StyleButton";
import { OnlyDateTimeConverter } from "../../Components/Helpers/DateTimeConverter";
import { PostMethod } from "../../Helper/api";
import { toast } from "react-toastify";
import CustomDropDown from "../../Components/DropDown/CustomDropDown";

const CandidateApplications = () => {
  const navigate = useNavigate();
  const [JobApplications, setJobApplications] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [Loader, setLoader] = useState(false);
  const [Filters,setFilters]=useState()

  const GenderInfo=[
    {label:"All",value:"All"},
    {label:"Not Completed",value:"Not Completed"},
    {label:"Call Letter Received",value:"Call Letter Received"},
    {label:"Phy-Approved",value:"Phy-Approved"},
    {label:"CBT-Completed",value:"CBT-Completed"},
    {label:"Medical Approved",value:"Medical Approved"},
    {label:"Medical-Rejected",value:"Medical-Rejected"},
    {label:"Rejected",value:"Rejected"},
    {label:"Finalized",value:"Finalized"},
  ]
  const HandleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };
  const HandleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const NavigateToDetails = (id) => {
    if(id.status!="Pending"){
      navigate("/appliedjobs/details/"+id.job_application_uuid)
    }
  
  }
  useEffect(()=>{
    GetApplications()
  },[])
  const GetApplications=async()=>{
    try{
      const userid = localStorage.getItem("@userid");
      if(!userid){
        toast.warn("User authentication Failed ");
        return;
      }
      let url ="candidate/applicationlist"
      let method ="POST"
      let params ={
        "candidate_uuid":userid
      }
      setLoader(true)
      const response = await PostMethod({url,method,params})
      if(response.status){
        let array =[]
        response.result?.map((item)=>{
          let status = ""
          if(item.rejected_status){
            if(!item.applications_accepted){
              status ="Rejected"
            }
            if(!item.phy_accepted && item.applications_accepted){
              status ="phy-rejected"
            }
            if(item.cbt_accepted && !item.medical_accepted){
              status ="cbt-rejected"
            }
            if(item.medical_accepted){
              status ="medical-rejected"
            }
          }
         
          if(item.job_current_status=="submitted"){
            array.push({...item,status:"under review"})
          }else{
            array.push({...item,
              status:status!=""? status: item.job_current_status =="submitted"? "Under Review":item.job_current_status =="accepted"? "Call Letter Received": 
                item.job_current_status=="phy-approved"?"phy-approved" : item.job_current_status=="cbt_call_letter"? "Call Letter Received":
                  item.job_current_status=="cbt_completed"?"CBT-Completed":item.job_current_status=="medical_call_letter"? "Call Letter Received"
                    :item.job_current_status=="Medical-Approved"? "Medical-Completed":item.job_current_status=="pending"? "Not Completed":
                      item.job_current_status =="cbt_rejected"?"Rejected":item.job_current_status =="rejected"? "Rejected": item.job_current_status=="medical-approved"?"Medical Approved": item.job_current_status=="cbt_submitted"?"CBT-Completed": "Finalized"
            })
          }
        })
        setTableData(array)
        setJobApplications(array)
        setLoader(false)
      }else{
        setLoader(false)
      }
    }catch(Error){
      setLoader(false)
      console.log("err in GetApplications",Error)
    }
  }
  const FiltersDatas = (values)=>{
    setFilters(values)
    let datas = [...JobApplications]
    if(values!="All"){
      setLoader(true)
      datas = datas?.filter((item)=>{
        return (item.status == values)
      })
   
      setPage(0)
      setRowsPerPage(10)
      setTableData(datas)
    }else{
      setTableData(datas)
    }
    setLoader(false)
  }
  return (
    <Grid container item lg={12} sm={12} md={12} xs={12} >
      <Grid item container justifyContent={"space-between"} className="pt-3">
        <Grid item bgcolor={"#FFFFFF"} borderRadius={"6px"} className="p-3 w-100">
          <Grid container lg={12} className="p-3">
         
            <h4 className="Text-Prime-Black poppinsBold text-left" >Applied Job</h4>
            {Loader&& <Grid container lg={12} className="p-3" flexDirection={"row"} justifyContent={"center"} >
              <CircularProgress size="2rem" style={{ color: "#000" }} />
            </Grid>}
            <Grid container lg={12} className="p-3">
              <Grid lg={3}>
                <CustomDropDown placeholder={"Select Job Status"}  data={GenderInfo} borderRadius={"8px"} backgroundColor="#FFFFFF" selected={ Filters && {label: Filters,value: Filters}} onChange={(e) => FiltersDatas(e.value)}  />
              </Grid>
            </Grid>
            <TableContainer className="mt-3">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>Application Number</StyledTableCell>
                    <StyledTableCell>Job Name</StyledTableCell>
                    <StyledTableCell>Applied Date</StyledTableCell>
                    <StyledTableCell>Last Updated on</StyledTableCell>
                    <StyledTableCell align="center">Status</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                {tableData.length >0 ? (
                  <TableBody>
                    {tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => (
                      <StyledTableRow key={i}>
                        <StyledTableCell align="left">
                          <p className="Text-DK-Green  poppinsRegular pointer" role="presentation" onClick={() => NavigateToDetails(row)}>{row?.application_serial}</p>
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <p className="text-black poppinsRegular">{row?.job_name}</p>
                        </StyledTableCell>
                        <StyledTableCell align="left" >
                          <p className="Text-Prime-Black poppinsRegular">  {row?.submited_on ? OnlyDateTimeConverter(row.submited_on) : "--"}</p>
                        </StyledTableCell>
                        <StyledTableCell align="left" >
                          <p className="Text-Prime-Black poppinsRegular">  {row?.job_updated_on ? OnlyDateTimeConverter(row.job_updated_on) : "--"}</p>
                        </StyledTableCell>

                        <StyledTableCell align="left" >
                          <p style={{textTransform:"capitalize"}} className={StatusStyle(row.status)}>{(localStorage.getItem("@userType") == "fieldagentsupervisor") ? row.status + "-" : ""}{row.status ? row.status : "-"}</p>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                ) : (
                  <TableBody>
                    <StyledTableCell colSpan={5} align="center">
                      <Grid item container lg={12} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                        <h5 className="text-black poppinsMedium mb-3">You haven&lsquo;t applied for any jobs yet. Explore Job Openings to get started!</h5>
                      </Grid>
                    </StyledTableCell>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <Grid item container lg={12} justifyContent={"flex-end"}>
              {tableData.length > 10 ? (
                <CustomTablePagination
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  colSpan={7}
                  component="div"
                  count={tableData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={HandleChangePage}
                  onRowsPerPageChange={HandleChangeRowsPerPage}
                />
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        </Grid>

      </Grid>

    </Grid >

  );
};

export default CandidateApplications;